import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Create a new route
export const createRoute = async (formBody) => {
  return toast.promise(
    customFetch("routes", {
      method: "POST",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Creating route...",
      success: (data) => `${data.message}`,
      error: "Failed to create route",
    }
  );
};

// Update an existing route
export const updateRoute = async (formBody) => {
  return toast.promise(
    customFetch(`routes`, {
      method: "PUT",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Updating route...",
      success: (data) => `${data.message}`,
      error: "Failed to update route",
    }
  );
};

// Delete a route
export const deleteRoute = async (id) => {
  return toast.promise(
    customFetch(`routes/${id}`, {
      method: "DELETE",
    })
      .then((response) => {
        // Check if response is already parsed
        if (typeof response === "object" && response !== null) {
          return response;
        }

        // If it's not parsed, try to parse it
        try {
          return JSON.parse(response);
        } catch (e) {
          // If parsing fails, return the response as is
          return { status: true, message: response };
        }
      })
      .then((data) => {
        if (!data.status) {
          throw new Error(data.message || "Delete failed");
        }
        return data;
      }),
    {
      loading: "Deleting route...",
      success: (data) => data.message || "Delete successful",
      error: (err) => err.message || "Failed to delete route",
    }
  );
};

// Fetch all routes
export const getAllRoutes = async () => {
  try {
    const response = await customFetch("routes", {
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching routes:", error);
    throw error;
  }
};

// Fetch all routes
export const getRoutesByEmirates = async (emirateId) => {
  try {
    const response = await customFetch(`routes/by-emirate/${emirateId}`, {
      method: "GET",
    });
    console.log("🚀 ~ getRoutesByEmirates ~ response:", response);
    return response;
  } catch (error) {
    console.error("Error fetching routes:", error);
    throw error;
  }
};

// Delete all routes
export const deleteAllRoutes = async () => {
  return toast.promise(
    customFetch("routes-delete/deleteall", {
      method: "DELETE",
    }).then((data) => {
      if (!data.status) {
        throw new Error(data.message || "Delete all failed");
      }
      return data;
    }),
    {
      loading: "Deleting all routes...",
      success: (data) => data.message || "All routes deleted successfully",
      error: (err) => err.message || "Failed to delete all routes",
    }
  );
};
